export default __webpack_public_path__ + "static/media/aws.1baaa078.svg";